import React from 'react';
import styled from '@emotion/styled';

import SectionDark from '../shared/SectionDark';

import respond from '../../styles/mediaQueries';

const StyledHeader = styled('div')` 
    margin-bottom: 12rem;
`;

const Container = styled('div')` 
	display: grid;
	grid-template-columns: minmax(min-content, 44rem) 1fr; 

	${respond('bp1')} {
		grid-template-columns: 1fr 1fr; 
	}

	${respond('bp4')} {
		grid-template-columns: 1fr;

	}
`;

const PageHeader = ({ children }) => {
	return (
		<StyledHeader>
			<SectionDark>
				<Container>{children}</Container>
			</SectionDark>
		</StyledHeader>
	);
};

export default PageHeader;
